import axios from "axios";

export const instance = axios.create({
  timeout: 10000
});

export const getRequestList = () => {
  return instance({
    method: "get",
    url: "/work/api/request-study"
  });
};

export const getRequestCard = id => {
  return instance({
    method: "get",
    url: `/work/api/request-program/${id}/card`
  });
};

export const getRequestMain = id => {
  return instance({
    method: "get",
    url: `/work/api/request-program/${id}/main`
  });
}

export const getRequestMeta = id => {
  return instance({
    method: "get",
    url: `/work/api/request-program/${id}`
  });
}

export const getRequestPlan = id => {
  return instance({
    method: "get",
    url: `/work/api/request-program/${id}/plan`
  });
}

export const getRequestGroup = id => {
  return instance({
    method: "get",
    url: `/work/api/request-program/${id}/group`
  });
}

export const getRequestProgram = id => {
  return instance({
    method: "get",
    url: `/work/api/request-program/${id}/program`
  });
}

export const getRelationRequests = id => {
  return instance({
    method: "get",
    url: `/work/api/request-program/${id}/request-relations`
  });
}

export const getRelationStudents = id => {
  return instance({
    method: "get",
    url: `/work/api/request-program/${id}/student-relations`
  });
}

export const getMatchPersons = (email, firstName, lastName, middleName) => {
  const data = {
    email:email,
    firstName:firstName,
    lastName:lastName,
    middleName:middleName
  };
  return instance({
    method: "get",
    url: `/work/api/request-program/same-person`,
    data
  });
}

export const getWorkInfo = (id) => {
  return instance({
    method: "get",
    url: `/work/api/request-program/${id}/workinfo`
  });
}

export const getWorkProcessList = (id) => {
  return instance({
    method: "get",
    url: `/work/api/request-program/${id}/work-process`
  });
}

export const getFilters = () => {
  return instance({
    method: "get",
    url: "/work/api/request-program/filters"
  });
}

export const createRequest = (data) => {
  return instance({
    method: "post",
    url: `/work/api/platform-request-program`,
    data
  });
}

export const sendToWork = (id) => {
  const data = {
    type: "sendToWork",
    id: id
  }
  return instance({
    method: "post",
    url: `/work/api/request-program/rpc`,
    data
  });
}

export const sendToApprove = (id, comment) => {
  const data = {
    type: "sendToApprove",
    id: id,
    comment: comment
  }
  return instance({
    method: "post",
    url: `/work/api/request-program/rpc`,
    data
  });
}

export const sendToApproveMany = (requests, groupId, newGroupData) => {
  const data = {
    type: "sendToApproveMany",
    requests: requests || [],
    groupId: groupId,
    newGroupData: newGroupData
  }
  return instance({
    method: "post",
    url: `/work/api/request-program/rpc`,
    data
  });
}

export const sendToDecline = (id, comment) => {
  const data = {
    type: "sendToDecline",
    id: id,
    comment: comment
  }
  return instance({
    method: "post",
    url: `/work/api/request-program/rpc`,
    data
  });
}

export const sendToDeclineMany = (requests, comment) => {
  const data = {
    type: "sendToDeclineMany",
    requests: requests || [],
    comment: comment
  }
  return instance({
    method: "post",
    url: `/work/api/request-program/rpc`,
    data
  });
}

export const sendToArchive = (id) => {
  const data = {
    type: "sendToArchive",
    id: id
  }

  return instance({
    method: "post",
    url: `/work/api/request-program/rpc`,
    data
  });
}

export const setGroup = (id, groupId, newGroupData) => {
  const data = {
    type: "setGroup",
    id: id,
    groupId: groupId,
    newGroupData: newGroupData
  }
  return instance({
    method: "post",
    url: `/work/api/request-program/rpc`,
    data
  });
}

export const setPlan = (id, planId) => {
  const data = {
    type: "setPlan",
    id: id,
    planId: planId
  }
  return instance({
    method: "post",
    url: `/work/api/request-program/rpc`,
    data
  });
}

export const setProgram = (id, programId) => {
  const data = {
    type: "setProgram",
    id: id,
    programId: programId
  }
  return instance({
    method: "post",
    url: `/work/api/request-program/rpc`,
    data
  });
}

export const setPerson = (id, personId) => {
  const dataAdd = {
    type: "setPerson",
    id: id,
    personId: personId
  };

  const dataRemove = {
    type: "removePerson",
    id: id
  };

  const data = personId ? dataAdd : dataRemove;

  return instance({
    method: "post",
    url: `/work/api/request-program/rpc`,
    data
  });
}

export const setStudent = (id, personId) => {
  const dataAdd = {
    type: "setStudent",
    id: id,
    personId: personId
  };

  const dataRemove = {
    type: "setStudent",
    id: id
  };

  const data = personId ? dataAdd : dataRemove;

  return instance({
    method: "post",
    url: `/work/api/request-program/rpc`,
    data
  });
}

export const createRequestPerson = data => {
  return instance({
    method: "post",
    url: `/work/api/person`,
    data
  });
};

export const createRequestStudent = data => {
  return instance({
    method: "post",
    url: `/work/api/student`,
    data
  });
};

export const deleteRequestProgram = id => {
  return instance({
    method: "delete",
    url: `/work/api/request-program/${id}`
  });
};

export const calcSimilarRecords = () => {
  return axios.get(`/work/api/request-program-calc`, {
    timeout: 20000,
    headers: {
      'Accept': 'application/json'
    }
  });
};

export const checkSameProgram = (list) => {
  const data = {
    type: "check-same-program",
    requests: list
  };

  return instance({
    method: "post",
    url: `/work/api/request-program/rpc`,
    data
  });
}

export default {
  getRequestMeta,
  getRequestList,
  getRequestCard,
  getRequestMain,
  getRelationRequests,
  getRelationStudents,
  getMatchPersons,
  getWorkInfo,
  getWorkProcessList,
  getRequestPlan,
  getRequestGroup,
  getRequestProgram,
  sendToWork,
  sendToApprove,
  sendToApproveMany,
  sendToDecline,
  sendToDeclineMany,
  sendToArchive,
  setGroup,
  setPlan,
  setPerson,
  setStudent,
  setProgram,
  createRequestPerson,
  createRequestStudent,
  deleteRequestProgram,
  calcSimilarRecords,
  getFilters,
  createRequest,
  checkSameProgram
};
